export { Severity } from './severity';
export { SeverityLevels } from './severity';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/types/esm/index.js
// module id = 39
// module chunks = 0